import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Link, Typography } from '@material-ui/core';
import courses from '../content';

const useStyles = makeStyles(() => ({
  courseCard: {
    margin: '0 auto',
  },
  courseImg: {
    // padding: "50px",
  },
}));

function Common() {
  const classes = useStyles();
  return (
    <Grid container justify="center">
      {courses.coursesList.map((item) => (
        <Grid item container xs={12} sm={6} md={4} style={{ zIndex: 0 }} key={item.name}>
          <div className={`${classes.courseCard} zoom`} style={{ width: 170 }}>
            <Grid
              item
              xs
              style={{
                padding: '0 0 50px 0', margin: 0, width: '200%', maxWidth: '170px',
              }}
            >
              <Link href={`/kursy/${item.id}`} underline="none">
                {item.icon}
                <Grid item xs style={{ textAlign: 'center', padding: '25px 0 0 0' }}>
                  <Typography variant="h6" style={{ color: 'black', lineHeight: '140%' }}>
                    {item.name}
                  </Typography>
                </Grid>
              </Link>
            </Grid>
          </div>

        </Grid>
      ))}

    </Grid>
  );
}
export default Common;
